// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__5i1+e","Checkbox__Input":"Checkbox_Checkbox__Input__Q8ujd","Checkbox__Text":"Checkbox_Checkbox__Text__9PH3I"};